import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'surfaceType'
})
export class SurfaceTypePipe implements PipeTransform {

  transform(value: 'AIR' | 'AREA'): string {
    return value === 'AIR'
      ? $localize`Воздух`
      : $localize`Поверхность`;
  }

}
